import { render } from "./Contact.vue?vue&type=template&id=af870d78&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=af870d78&scoped=true&lang=css"

import exportComponent from "D:\\projects\\RED MENACE\\redmenacegames.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af870d78"]])

export default __exports__